import {Observable} from 'rxjs'

export interface IHttpRestClient {
    get(url: string, params?: object): Observable<HttpResponse>;

    post(url: string, data?: any): Observable<HttpResponse>

    put(url: string, data?: any): Observable<HttpResponse>

    patch(url: string, data?: any): Observable<HttpResponse>

    options(url: string): Observable<HttpResponse>

    delete(url: string, params?: object): Observable<HttpResponse>
}

// HTTP response object. This is a wrapper for the AXIOS implementation
export class HttpResponse {
    status?: number;
    statusText?: string;
    data?: any;
    error?: any;
    headers?: any;

    constructor(status?: number, statusText?: string, data?: any, error?: any, headers?: any) {
        this.status = status;
        this.statusText = statusText;
        this.data = data;
        this.error = error;
        this.headers = headers;
    }
}
